import { Box, Typography } from '@mui/material'
import { volunteerPhoto } from '../../assets/index'
import PrimaryButton from '../common/PrimaryButton'
import SecondaryButton from '../common/SecondaryButton'
import { plcCta } from '../../data/plcContent'

const IMAGE_WIDTH = 1632
const IMAGE_HEIGHT = 774

export default function PlcCtaBanner() {
  return (
    <Box
      component="section"
      sx={{
        position: 'relative',
        width: '100%',
        maxWidth: 1520,
        mx: 'auto',
        minHeight: { xs: 440, sm: 480, lg: 500 },
        height: { lg: 500 },
        borderRadius: '20px',
        overflow: 'hidden',
        bgcolor: '#e9e9e9',
        boxSizing: 'border-box',
      }}
    >
      <Box
        aria-hidden
        sx={{
          position: 'absolute',
          top: 'calc(50% + 12px)',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: `${(IMAGE_WIDTH / 1520) * 100}%`, lg: IMAGE_WIDTH },
          minWidth: { xs: '200%', sm: '180%', lg: IMAGE_WIDTH },
          height: { xs: `${(IMAGE_HEIGHT / 500) * 100}%`, lg: IMAGE_HEIGHT },
          minHeight: { xs: '140%', sm: '130%', lg: IMAGE_HEIGHT },
          pointerEvents: 'none',
        }}
      >
        <Box
          sx={{
            width: '100%',
            height: '100%',
            transform: 'scaleY(-1) rotate(180deg)',
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          <Box
            component="img"
            src={volunteerPhoto}
            alt=""
            sx={{
              position: 'absolute',
              left: 0,
              top: '-0.05%',
              width: '99.99%',
              height: '100.1%',
              maxWidth: 'none',
              display: 'block',
            }}
          />
        </Box>
      </Box>

      <Box
        sx={{
          position: 'relative',
          zIndex: 1,
          width: '100%',
          maxWidth: 584,
          display: 'flex',
          flexDirection: 'column',
          gap: { xs: 3, lg: '32px' },
          alignItems: 'flex-start',
          p: { xs: 3, sm: 4, md: 5, lg: '60px' },
          boxSizing: 'border-box',
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '14px', width: '100%' }}>
          <Typography
            component="h2"
            sx={{
              fontSize: { xs: 22, sm: 32, lg: 26 },
              lineHeight: 'normal',
              fontWeight: 400,
              color: '#111',
            }}
          >
            {plcCta.title}
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: 16, sm: 16, lg: 16 },
              lineHeight: 'normal',
              fontWeight: 400,
              color: '#111',
            }}
          >
            {plcCta.description}
          </Typography>
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            gap: '20px',
            alignItems: { xs: 'stretch', sm: 'flex-start' },
            width: { xs: '100%', sm: 'auto' },
          }}
        >
          <PrimaryButton to="/contact">
            Register for PLC 4.0
          </PrimaryButton>

          <SecondaryButton to={plcCta.brochureUrl}>
            Download Brochure
          </SecondaryButton>
        </Box>
      </Box>
    </Box>
  )
}
